import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Restricts routes to JWT role `admin`; redirects everyone else to home. */
export const adminRoleGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAdmin()) {
    return true;
  }
  if (auth.isClientView()) {
    return router.createUrlTree(['/client-view/access-restricted']);
  }
  return router.createUrlTree(['/home']);
};
